import { useFirestoreGeneral } from '../../../firebase/useFirestore'
import Location from '../../../hooks/Location'
import ToggleButton from '../../common/ToggleButton'
import ReadOnlyGuard from '../../common/ReadOnlyGuard'

/**
 * De sectie 'Zelf op te pakken' op het tabblad Gegevens van een huishouden.
 *
 * Hiermee geeft de planner een huishouden vrij, zodat een klusser het zonder
 * overleg kan oppakken vanaf zijn telefoon. Het vinkje blijft aan staan als
 * iemand het oppakt: het zegt iets over de klus, niet over de beschikbaarheid.
 * Wat er verder moet kloppen voordat het op een telefoon verschijnt, staat in
 * `helpers/adressHelpers/selfPickup.js`.
 *
 * Dezelfde vorm als de secties op de deelnemerpagina: een eigen blok met een
 * `<h3>`. `dashboard-container` en NIET `table-container` -- dat laatste was
 * tot 2026-10-14 een scrollvak van 520px dat alleen om een tabel hoort.
 * AI-CONTEXT: See docs/pitfalls.md#ui-container-class-is-a-scroll-box
 *
 * Leest het huishouden zelf op in plaats van het als prop te krijgen: dezelfde
 * Firestore-listener als de rest van de pagina, dus dat kost niets extra's.
 *
 * AI-CONTEXT: See docs/features/huishouden-zelf-op-te-pakken.md
 *
 * @returns {JSX.Element|null}
 */
const SelfPickupCard = () => {
    const adressId = Location()[3]

    const adressList = useFirestoreGeneral('Adresses', 'ID', adressId || '')
    const adress = Array.isArray(adressList) && adressList.length > 0 ? adressList[0] : null

    // Zolang het huishouden nog onderweg is geen schakelaar tonen: die zou op
    // 'uit' staan terwijl we het niet weten, en een klik schrijft dan een
    // waarde weg die de gebruiker nooit gekozen heeft.
    // AI-CONTEXT: See docs/pitfalls.md#state-gate-defaults-open-while-loading
    if (!adress) return null

    return (
        <div className="dashboard-container adress-self-pickup">
            <h3>Zelf op te pakken</h3>
            <ReadOnlyGuard edit="addresses.edit">
                <ToggleButton
                    docid={adress.docid}
                    id="SelfPickup"
                    value={adress.SelfPickup}
                    collection="Adresses"
                />
            </ReadOnlyGuard>
        </div>
    )
}

export default SelfPickupCard
